import React, { useCallback, useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import InvoicesTable from './Invoices/InvoicesTable';
import { getInvoicesRequest } from '../../store/modules/billing/actions';
import { User } from '../../types/items';
import { selectInvoices } from '../../store/modules/billing/selectors';
import { RadioGroup, SimpleButton } from '../../components';
import Spinner from '../../components/spinner/Spinner';
import { getAllQueryData, updateQuery } from '../../utility/helpers';
import useStyles from './styles';
import { statusInvoiceOptions } from './constants';

type Props = {
  user: User;
};

const InvoicesPage = ({ user }: Props) => {
  const dispatch = useDispatch();
  const { data: invoices, loading: invoiceLoading } = useSelector(selectInvoices);
  const [limit, setLimit] = useState(6);
  const queryData = getAllQueryData();
  const classes = useStyles();

  const statusFromQuery = statusInvoiceOptions
    .find((s) => s.id === queryData.status) && queryData.status;
  const [status, setStatus] = useState<string>(statusFromQuery || 'paid');

  const onChangeRadio = useCallback((newStatus) => {
    setStatus(newStatus);
    setLimit(6);
  }, [setStatus, setLimit]);

  // eslint react-hooks/exhaustive-deps: 0
  useEffect(() => {
    updateQuery({ status });
    dispatch(getInvoicesRequest({ userId: user.id, limit, status }));
  }, [dispatch, user, limit, status]);

  if (invoiceLoading) {
    return <Spinner />;
  }

  return (
    <div>
      <RadioGroup value={status} onChange={onChangeRadio} options={statusInvoiceOptions} direction="horizontal" />
      {(invoices && <InvoicesTable invoices={invoices} />) || <div className={classes.noDataTip}>No data</div>}
      {(limit !== 1000 && invoices && (invoices.length >= 6))
        && (
          <SimpleButton onClick={() => setLimit(1000)}>
            Show All Invoices
          </SimpleButton>
        )}
    </div>
  );
};

export default InvoicesPage;
